<template>
  <!--

  - Si tiene fecha de entrata y no  tiene gia o idpaquete (indica que esta en el almacen pero no  ha sido proocesado) el paquete se encuantra en nuestras instalaciones, cree una prealerta para agilizar el proceso.
  - Si no tiene fecha  de entrada ni  id paquete, El paquete no esta  en nuestro alamacen para agilizar el proceso de registro al legar prealerte el mismo.
  - si no  tiene fecha de entrada, pero si tiene guia, (Indica que no  se le dio entrada en miami)

  -->
  <v-container class="no-p" fluid>
    <v-app-bar app>
      <v-btn icon to="/home">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <!-- <v-btn icon><v-icon>keyboard_arrow_left</v-icon></v-btn> -->
      <v-toolbar-title>Solicitar Información</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon to="/home">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-app-bar>

    <div class="pt-4 pl-4 pr-4 mb-4">
      <v-card class="login-form">
        <v-card-text class="pb-0">
          <v-form v-model="valid" ref="form">
            <h2 class="headline mb-4">Razón de la reclamación</h2>

            <v-select
              solo
              required
              v-model="text4"
              label="Tipo de reclamación"
              :rules="required"
              :items="listTypeClaims"
              item-text="descripcion"
              item-value="id_tipo_reclamacion"
            ></v-select>

            <v-text-field
              solo
              required
              :rules="required"
              v-model="text5"
              label="Número de Tracking"
              type="text"
            ></v-text-field>
            <v-textarea solo name="input-7-4" v-model="text6" label="Nota"></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="!valid" block color="primary" @click="createClaims">Crear</v-btn>
        </v-card-actions>
      </v-card>
    </div>

    <div class="list-of-content" v-if="items.length > 0">
      <v-list three-line>
        <template v-for="(item, index) in items">
          <v-list-item :key="index">
            <v-list-item-content>
              <v-list-item-title class="list-of-content__title" v-html="item.asunto_recla"></v-list-item-title>

              <table class="list-of-content__details">
                <tr>
                  <th>No. Reclamación</th>
                  <td>{{item.noreclamacion}}</td>
                </tr>
                <tr>
                  <th>Fecha</th>
                  <td>{{item.fec_creacion}}</td>
                </tr>
                <tr>
                  <th>Estatus</th>
                  <td>{{item.desc_estatus}}</td>
                </tr>
                <tr>
                  <th>Número de Tracking</th>
                  <td>{{item.tracking_number}}</td>
                </tr>
              </table>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </div>
  </v-container>
</template>

<script>
import Helpers from "../utils/helpers";
import Server from "../utils/server";
export default {
  data() {
    return {
      clipped: false,
      currentUser: undefined,
      noData: false,
      loading: false,
      text4: "",
      Searh: [],
      valid: false,
      items: [],
      listTypeClaims: [],
      required: [v => !!v || Language[this.lg].the_field_is_required]
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    login() {
      return this.$store.getters.login;
    },
    profile: function() {
      return this.$store.getters.profile;
    }
  },
  mounted() {
    if (this.currentUser != undefined) {
      this.getPacks();
      this.getTypeClaim();
    } else if (this.user.userName != null) {
      this.currentUser = this.user;
      this.getPacks();
      this.getTypeClaim();
    }
  },
  methods: {
    pickFile(guia, idpack) {
      window.MobileApi.uploadInvoice(
        Server.uploadInvoice,
        guia,
        idpack,
        this.currentUser.userName,
        () => {
          this.validateLogin();
        }
      );
    },
    validateLogin: function() {
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      formData.append("text6", this.text4);

      Helpers.getJson(Server.buscar, "POST", formData, json => {
        console.log(json);
        if (json.length > 0) {
          this.Searh = json;
        } else {
          this.Searh = [];
        }
      });
      // this.$router.push('prealert')
    },
    getPacks() {
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      this.$http.post(Server.listClaims, formData).then(
        response => {
          if (response.body.resultado !== "NO") {
            this.items = response.body;
          } else {
            this.noData = true;
          }
        },
        () => {
          this.error = true;
          this.msj = "Try again later";
        }
      );
    },
    getTypeClaim() {
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      this.$http.post(Server.listTypeClaims, formData).then(
        response => {
          if (response.body.resultado !== "NO") {
            this.listTypeClaims = response.body;
          } else {
            this.noData = true;
          }
        },
        () => {
          this.error = true;
          this.msj = "Try again later";
        }
      );
    },
    createClaims() {
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("text4", this.text4);
      formData.append("text5", this.text5);
      formData.append("text6", this.text6);
      formData.append("device", window.MobileApi.device);
      this.$http.post(Server.CreateClaims, formData).then(
        response => {
          if (response.body.resultado !== "NO") {
            this.items = response.body;
            this.$refs.form.reset();
          } else {
            this.noData = true;
          }
        },
        () => {
          this.error = true;
          this.msj = "Try again later";
        }
      );
    }
  },
  name: "App"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
